import { showToast, showErrorToast } from "@/helpers/actions/helpers";
import CorrectionReportService from "@/service/CorrectionReportService";

class ResendLoanActions {
    items = [];
    menuItems= [];

    beforeResend = null;
    afterResend = null;

    constructor(data) {
        if (data.status !== 'new' && data.fileId !== null) {
            this.items.push({
                label: 'Скачать файл',
                icon: 'pi pi-fw pi-download',
                command: () => this.download(data.id)
            });
        }

        this.items.push({
            label: 'Переотправить',
            icon: 'pi pi-fw pi-replay',
            command: () => this.resend(data.id),
            viewOnly: true
        });

        this.items.push({
            label: 'Сбросить',
            icon: 'pi pi-fw pi-replay',
            command: () => this.reset(data.id),
            viewOnly: true
        });

        this.menuItems = this.items.filter((item) => item.viewOnly !== true);
    }

    resend(id) {
        if (this.beforeResend != null)
            this.beforeResend();

        CorrectionReportService.resend(id).then((res) => {
            showToast(res.feedback, res.error);
        })
            .catch((err) => {
                showErrorToast(err);
            })
            .finally(() => {
                if (this.afterResend != null)
                    this.afterResend();
            })
    }

    reset(id) {
        CorrectionReportService.reset(id).then((res) => {
            showToast(res.feedback, res.error);
        })
            .catch((err) => {
                showErrorToast(err);
            })
    }

    download(id) {
        window.open(`/download/correction_report/${id}`, '_blank');
    }

    getItems() {
        return this.items;
    }

    getMenuItems() {
        return this.menuItems;
    }
}

export default ResendLoanActions;